import { Slugs } from 'common/urls/Slugs';
import { isEmpty, isNull } from 'lodash';
import React, { useCallback, useContext, useEffect, useRef } from 'react';
import { useHistory } from 'react-router';
import { isNativeMobileApp } from 'src/mobile-app/isNativeMobileApp';
import { useSearchReducer } from 'src/pages/consumer/components/DishFirstHeader/store';
import { useScrollLock } from 'src/shared/hooks/useScrollLock';
import { Routes } from 'src/shared/Routes';
import { getSluggedPath } from 'src/shared/utils/RouteUtilities';
import { useSearchQueryState } from '../../store/hooks/useSearchQuery';
import { SearchDataContext } from '../../store/SearchDataContext';
import { PartialStateResults } from './PartialStateResults';
import { Container, CONTENT_CONTAINER_MOBILE_OFFSET, CONTENT_CONTAINER_OFFSET, ContentContainer } from './styles';
import { TrendingSearches } from './TrendingSearches';

export interface SearchDropdownProps {}

export const SearchDropdown: React.FC<SearchDropdownProps> = () => {
  const history = useHistory();
  const { handleQueryChange, isSearchHidden, activeZipCode } = useContext(SearchDataContext);
  const query = useSearchQueryState();
  const { hide, isShowing } = useSearchReducer();

  const ref = useRef<HTMLDivElement>(null);
  const isMobileApp = isNativeMobileApp();

  const handleClickTrend = useCallback(
    (searchTerm: string) => {
      const path = getSluggedPath(Routes.CONSUMER_ORDER_SEARCH, [{ slug: Slugs.ZIP_CODE, value: activeZipCode ?? '' }]);
      history.push(path + history.location.search);
      handleQueryChange(searchTerm, false);
      hide();
    },
    [history, activeZipCode, handleQueryChange, hide]
  );

  useEffect(() => {
    if (isSearchHidden && isShowing) {
      hide();
    }
  }, [isSearchHidden, hide, isShowing]);

  useScrollLock({
    enabled: isShowing,
    scrollableTargetRef: ref,
  });

  return isSearchHidden ? null : (
    <Container isShowing={isShowing}>
      <ContentContainer
        autoUpdate={isShowing}
        offsetHeight={isMobileApp ? CONTENT_CONTAINER_MOBILE_OFFSET : CONTENT_CONTAINER_OFFSET}>
        {isEmpty(query) && (
          <>
            {isNull(activeZipCode) ? null : (
              <TrendingSearches onClickTrend={handleClickTrend} zipCode={activeZipCode} />
            )}
          </>
        )}
        {!!query && <PartialStateResults onClickViewAll={() => handleClickTrend(query)} />}
      </ContentContainer>
    </Container>
  );
};
